import { FormattedMessage, useIntl } from 'react-intl';
import { Basket } from '../../../utils/checkoutState';
import EllipsisText from '../../atoms/EllipsisText';
import FormattedCurrency from '../../atoms/FormattedCurrency';
import ToolTip from '../../atoms/ToolTip';

const DutiesAndTaxes = ({ pricingEstimations }: { pricingEstimations: Basket['pricingEstimations'] }) => {
  const { formatMessage } = useIntl();

  if (!pricingEstimations) {
    return (
      <div className="price-summary__error-information">
        <FormattedMessage id="basket.dutiesAndTaxes.informationErrorText" />
      </div>
    );
  }

  const dutiesLocalAmount = pricingEstimations?.totals.duties.localCurrency.amount;
  const dutiesLocalCurrency = pricingEstimations?.totals.duties.localCurrency.currency;
  const dutiesOriginalAmount = pricingEstimations?.totals.duties.originalCurrency.amount;
  const dutiesOriginalCurrency = pricingEstimations?.totals.duties.originalCurrency.currency;

  const taxesLocalAmount = pricingEstimations?.totals.taxes.localCurrency.amount;
  const taxesLocalCurrency = pricingEstimations?.totals.taxes.localCurrency.currency;
  const taxesOriginalAmount = pricingEstimations?.totals.taxes.originalCurrency.amount;
  const taxesOriginalCurrency = pricingEstimations?.totals.taxes.originalCurrency.currency;

  const totalFeesLocalAmount = pricingEstimations?.totals.totalFees.localCurrency.amount;
  const totalFeesLocalCurrency = pricingEstimations?.totals.totalFees.localCurrency.currency;
  const totalFeesOriginalAmount = pricingEstimations?.totals.totalFees.originalCurrency.amount;
  const totalFeesOriginalCurrency = pricingEstimations?.totals.totalFees.originalCurrency.currency;

  return (
    <div>
      <dl className="price-summary__section">
        <dt className="price-summary__title price-summary__title--big price-summary__total-duties-taxes">
          <EllipsisText className="price-summary__total-duties-taxes-label">
            <FormattedMessage id="basket.dutiesAndTaxes.totalDutiesAndTaxes" />
          </EllipsisText>
          <ToolTip
            content={formatMessage({ id: 'basket.dutiesAndTaxes.informationBoxText' })}
            dataTestId="total-duties-taxes"
          />
        </dt>
        <dd className="price-summary__value price-summary__value--big" data-test-id="basket-total-fees-local-amount">
          <FormattedCurrency value={totalFeesLocalAmount!} differentCurrency={totalFeesLocalCurrency} />
        </dd>
        <dd className="price-summary__value price-summary__value--big" data-test-id="basket-total-fees-original-amount">
          <FormattedCurrency value={totalFeesOriginalAmount!} differentCurrency={totalFeesOriginalCurrency} />
        </dd>
      </dl>
      <dl className="price-summary__section">
        <dt className="price-summary__title">
          <FormattedMessage id="basket.dutiesAndTaxes.duties" />
        </dt>
        <dd className="price-summary__value" data-test-id="basket-duties-local-amount">
          <FormattedCurrency value={dutiesLocalAmount!} differentCurrency={dutiesLocalCurrency} />
        </dd>
        <dd className="price-summary__value" data-test-id="basket-duties-original-amount">
          <FormattedCurrency value={dutiesOriginalAmount!} differentCurrency={dutiesOriginalCurrency} />
        </dd>
      </dl>
      <dl className="price-summary__section">
        <dt className="price-summary__title">
          <FormattedMessage id="basket.dutiesAndTaxes.taxes" />
        </dt>
        <dd className="price-summary__value" data-test-id="basket-taxes-local-amount">
          <FormattedCurrency value={taxesLocalAmount!} differentCurrency={taxesLocalCurrency} />
        </dd>
        <dd className="price-summary__value" data-test-id="basket-taxes-original-amount">
          <FormattedCurrency value={taxesOriginalAmount!} differentCurrency={taxesOriginalCurrency} />
        </dd>
      </dl>
      <p className="price-summary__annotation">
        <FormattedMessage id="basket.dutiesAndTaxes.informationText" />
      </p>
    </div>
  );
};
export default DutiesAndTaxes;
